import { Company } from './Company';

export class Treasury {
  id: number;
  code: string;
  name: string;

  company: Company;
  mrt: string;

  constructor(data?: any) {
    if (data) {
      Object.assign(this, data);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/model/Treasury.ts